import { Collection, Map } from 'immutable'
import toString from 'lodash-es/toString'
import { createImmutableEqualSelector } from '../../selectors/createImmutableEqualSelector'
import { Entity, Shipment } from '../../types/coreEntitiesTypes'

export const groupingSelector: <T>(
  state: Collection<number, Entity<T>>,
  groupFunction: (value: Entity<T>, key: number) => string,
  groupSortFunction: (a: Entity<T>, b: Entity<T>) => number
) => Map<string, Collection<number, Entity<T>>> = createImmutableEqualSelector(
  <T>(state: Collection<number, Entity<T>>) => state,
  <T>(_state: Collection<number, Entity<T>>, groupFunction: (value: Entity<T>, key: number) => string) => groupFunction,
  <T>(
    _state: Collection<number, Entity<T>>,
    _groupFunction: (value: Entity<T>, key: number) => string,
    groupSortFunction: (a: Entity<T>, b: Entity<T>) => number
  ) => groupSortFunction,
  <T>(
    state: Collection<number, Entity<T>>,
    groupFunction: (value: Entity<T>, key: number) => string,
    groupSortFunction: (a: Entity<T>, b: Entity<T>) => number
  ) => state.groupBy(groupFunction).map((group) => group.sort(groupSortFunction))
)

export const groupShipments = (s: Shipment) =>
  toString(s.get('groupId') ? s.get('groupId') : s.get('loadCarrierId') ? s.get('loadCarrierId') : s.get('id'))

export const sortShipmentGroupByGroupOrder = (a: Shipment, b: Shipment) =>
  (a.get('groupOrder') || 0) - (b.get('groupOrder') || 0)

export const groupItemsByMapKey = (v: any, k: number) => k.toString(10)
